import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'contract-types';

const createContractType = async (body) => {
  const method = 'POST';
  const url = `${USE_CASE_URL}`;

  const json = await request({ method, url, body });
  return json;
};

export default createContractType;
